'use strict';

export default class {

    /*@ngInject*/
    constructor($http, USUARIOS_URL){
        Object.assign(this, {$http, USUARIOS_URL});
    }

    editarUsuario(usuario){
        return this.$http.patch(this.USUARIOS_URL + '/update/' + usuario._id, usuario);
    }
    
    getUsuarioPorId(id){
        return this.$http.get(this.USUARIOS_URL + '/' + id);
    }
    
    crearUsuario(usuario){
        return this.$http.post(this.USUARIOS_URL, usuario);
    }
}


// WEBPACK FOOTER //
// ./client/app/usuario-route/usuario.service.js